// import { useNavigate } from "react-router"

import { useState } from "react";
import CTL_SVG from "./CTL_SVG";
import CTL_Modal from "./CTL_Modal";
import { CTL_Input } from "./CTL_Input";
import CTL_Button from "./CTL_Button";

export default function CTL_Footer(){
  // const navi = useNavigate();
  const [showModal, set_showModal] = useState( false );
    
  return <>
  <div className="
    border-t border-zinc-100
    w-full
    p-5 pb-20
    flex flex-col items-center
  ">
    <div className="w-full flex gap-1 items-start">
      <div className="w-full flex flex-col gap-2">
        <div className="w-full flex items-center">
          <div className="flex-1">
            <img src="/logo2.svg" className="h-[30px]"/>
          </div>
          <div className="border border-zinc-200 p-1 rounded-lg" onClick={ ()=>set_showModal(true) }>
            <CTL_SVG className="w-[15px] fill-zinc-400" d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z" />
          </div>
        </div>

        <div className="flex gap-1">
          <div className="w-[40px] h-[40px] rounded-full bg-black/5 flex flex-col items-center justify-center cursor-pointer" onClick={()=>window.open('https://www.instagram.com/_white.mark_', '_blank')}>
            <img src="/insta.png" className="w-[32px]"/>
            {/* <CTL_SVG className="w-[28px] fill-black/80" d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"/> */}
          </div>
          <div className="flex-1 px-3">
            <div>정보 관리 책임자 : 진주희</div>
            <div onClick={()=>location.href="mailto:jjh.keymaker@gmail.com"}>이메일 : jjh.keymaker@gmail.com</div>
          </div>
        </div>
      </div>
      
    </div>
    
  </div>
  {showModal&&
    <CTL_Modal onClose={ ()=>set_showModal(false) }>
      <div className="bg-white rounded-lg shadow-2xl w-[300px] p-2" onClick={(e)=>e.stopPropagation()}>
        <div className="flex flex-col gap-2">
          <div>관리자 로그인</div>
          <CTL_Input type="password" />
          <CTL_Button>로그인</CTL_Button>
        </div>
      </div>
    </CTL_Modal>
  }

  {/* <div className=" w-fit
        border border-zinc-200 rounded-md
        px-3 py-1 cursor-pointer text-nowrap
      " onClick={()=>navi('/admin')}>.</div> */}
  </>
}